import React, { createRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const RoundedCheck = ({ fill = '' }) => {
    const pathRef = createRef()
    useEffect(() => {
        if (pathRef?.current) {
            pathRef.current.style.fill = fill.length === 0 ? 'hsl(var(--primary))' : fill
        }
    }, [fill])
    return (
        <svg id="svg" ref={pathRef} stroke="#000000" width="30" height="30" version="1.1" viewBox="143 143 514 514" xmlns="http://www.w3.org/2000/svg" strokeWidth="0">
            <g id="IconSvg_bgCarrier" strokeWidth="0"></g>
            <g id="IconSvg_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC" strokeWidth="0">
                <path xmlns="http://www.w3.org/2000/svg" d="m400 173.29c-124.95 0-226.71 101.77-226.71 226.71s101.77 226.71 226.71 226.71 226.71-101.77 226.71-226.71c-0.003906-124.95-101.77-226.71-226.71-226.71zm132.5 150.13-171.3 171.3c-2.5195 2.5195-5.543 3.5273-9.0703 3.5273-3.0234 0-6.5508-1.5117-9.0703-3.5273l-75.566-76.578c-5.0391-5.0391-5.0391-13.098 0-17.633 5.0391-5.0391 13.098-5.0391 17.633 0l67.512 67.512 162.23-162.23c5.0391-5.0391 13.098-5.0391 17.633 0 5.0391 4.5312 5.0391 12.594 0 17.629z"></path>

            </g>
            <g id="IconSvg_iconCarrier">
                <path xmlns="http://www.w3.org/2000/svg" d="m400 173.29c-124.95 0-226.71 101.77-226.71 226.71s101.77 226.71 226.71 226.71 226.71-101.77 226.71-226.71c-0.003906-124.95-101.77-226.71-226.71-226.71zm132.5 150.13-171.3 171.3c-2.5195 2.5195-5.543 3.5273-9.0703 3.5273-3.0234 0-6.5508-1.5117-9.0703-3.5273l-75.566-76.578c-5.0391-5.0391-5.0391-13.098 0-17.633 5.0391-5.0391 13.098-5.0391 17.633 0l67.512 67.512 162.23-162.23c5.0391-5.0391 13.098-5.0391 17.633 0 5.0391 4.5312 5.0391 12.594 0 17.629z"></path>

            </g>
        </svg>
    )
}

RoundedCheck.propTypes = {
    fill: PropTypes.string
}

export default RoundedCheck
